// UserForm.jsx

import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { Button, Typography } from '@mui/material';
import { useSnackbar } from '../../../context/SnackbarContext';
import { useTranslation } from 'react-i18next';
import UserTypeSelect from '../../common/controls/UserTypeSelect';
import { useUpdateUserOffice } from '../../../hooks/users/useUpdateUserOffice';
import ConfirmDialog from '../../common/modals/ConfirmDialog';

export default function ChangeUserType({ userOffice = null, open, onClose, toggleUserListTrigger = null }) {
  const { t } = useTranslation('common'); 
  const { showSnackbar } = useSnackbar();
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

  const handleCancel = () => {
    onClose();
  };

  const [userType, setUserType] = useState(userOffice?.type || "");

  const onUpdateSuccess = () => {
    showSnackbar(t('users.messages.update_success'), "success");
    toggleUserListTrigger();
    handleCancel();
  };

  const { update } = useUpdateUserOffice(onUpdateSuccess);

  const handleChange = (value) => {
    setUserType(value);
  };

  const handleSave = async () => {
    try {
      let data = {
        "type": userType
      }
      await update(userOffice.id, data);
    } catch (err) {
      console.log("err.response", err.response);
      showSnackbar(t('users.messages.update_fail'), "error");
    }
    setConfirmDialogOpen(false);
  };

  return (
    <>
    <Dialog onClose={handleCancel} open={open} disableRestoreFocus>
      <DialogTitle>
        <>
          <Typography fontSize={20} fontWeight={700}>{userOffice?.office?.name}</Typography>
          <Typography fontSize={20} fontWeight={700}>{userOffice?.user?.name} </Typography>
        </>
      </DialogTitle>

      <DialogContent dividers>
        <Typography variant='body2'>
          Warning: Changing the user's account type will automatically log the user off.
        </Typography>
        <br />
        <UserTypeSelect 
          label='Account Type'
          value={userOffice?.type}
          onChange={handleChange}
        />
      </DialogContent>

      <DialogActions>
        <Button 
          onClick={() => setConfirmDialogOpen(true)}
        >
          Save
        </Button>
        <Button onClick={handleCancel}>Cancel</Button>
      </DialogActions>
    </Dialog>
    <ConfirmDialog
        open={confirmDialogOpen}
        title="Confirm Change Account Type"
        content={
          <>
            <Typography>Warning: User will be auto logged off and will need to sign in again.</Typography>
            <Typography>Click CONTINUE to confirm the action</Typography>
          </>
        }
        confirmText="Continue"
        cancelText="Cancel"
        onConfirm={handleSave}
        onCancel={() => setConfirmDialogOpen(false)}
        />
    </>
  );
}